/**
 * Collection Page Controller
 * Handles mobile filter drawer, sort selection updates, desktop filter submission,
 * and price range input handling. Built with native ES6 for Shopify OS 2.0.
 */

document.addEventListener('DOMContentLoaded', () => {
  initCollectionFilters();
  initMobileFilterDrawer();
  initSortSelectors();
});

function initCollectionFilters() {
  const form = document.querySelector('[data-filter-form]');
  if (!form) return;

  // Auto-submit form when checkboxes change on desktop
  form.addEventListener('change', (e) => {
    // Only auto-submit checkboxes on desktop; price ranges can be submitted via Enter
    if (e.target.type === 'checkbox') {
      form.submit();
    }
  });

  // Price range enter key handler
  form.querySelectorAll('.price-range__input').forEach((input) => {
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        form.submit();
      }
    });
  });
}

function initSortSelectors() {
  // Desktop sort select
  const desktopSort = document.querySelector('[data-sort-select]');
  if (desktopSort) {
    desktopSort.addEventListener('change', (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      // Reset to page 1 when sort changes
      url.searchParams.delete('page');
      window.location.href = url.href;
    });
  }
}

function initMobileFilterDrawer() {
  const drawer = document.querySelector('[data-mobile-filter-drawer]');
  const openBtn = document.querySelector('[data-mobile-filter-open]');
  if (!drawer || !openBtn) return;

  let lastActiveElement = null;

  function openDrawer() {
    lastActiveElement = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    const closeBtn = drawer.querySelector('.mobile-filter-drawer__close-btn');
    if (closeBtn) {
      setTimeout(() => closeBtn.focus(), 50);
    }
  }

  function closeDrawer() {
    drawer.hidden = true;
    document.body.style.overflow = '';
    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    } else {
      openBtn.focus();
    }
  }

  openBtn.addEventListener('click', openDrawer);

  drawer.querySelectorAll('[data-mobile-filter-close]').forEach((btn) => {
    btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (e) => {
    if (drawer.hidden) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if (e.key === 'Tab') {
      const focusables = drawer.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusables.length === 0) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
}
